import { DialogContent } from '@mui/material';

import {
  Button,
  DialogActions,
  useSwipeableViews,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { AgentCodeSnippet } from 'components/code';
import { AssignCredentialsDialogHeader } from 'hooks/dialogs/cluster/_components/AssignCredentialsDialogHeader';
import {
  AgentAutoscalerSetup,
  AgentOmniSetup,
} from 'hooks/dialogs/cluster/components/features';
import { useGetClusterOnboardingScriptQuery } from 'hooks/queries/omni';

import { useCluster } from '@cast/shared-cluster-context-data-access';

type RunTheScriptSlideProps = {
  onClose: () => void;
};

export const RunTheScriptSlide = ({ onClose }: RunTheScriptSlideProps) => {
  const swipeableViewsCtx = useSwipeableViews();

  const { cluster } = useCluster();
  const { script, isLoading, error, refetch } =
    useGetClusterOnboardingScriptQuery({
      clusterId: cluster.id,
    });

  return (
    <Stack position="relative" data-testid="run-the-script-slide">
      <AssignCredentialsDialogHeader dismiss={onClose} />
      <DialogContent sx={{ pb: 0 }}>
        <Typography
          variant="L10M"
          color={tokens.theme.fg.structural.secondary}
          mb={8}
        >
          Feature to be enabled:
        </Typography>

        <Stack>
          <AgentAutoscalerSetup hasBeenInstalled />
          <Stack gap={4} px={32} pb={16}>
            <Typography
              variant="L10M"
              color={tokens.theme.fg.structural.secondary}
            >
              Advanced (optional)
            </Typography>
            <AgentOmniSetup checked readonly />
          </Stack>
        </Stack>

        <Typography
          variant="L10M"
          color={tokens.theme.fg.structural.secondary}
          mb={8}
        >
          Run the script:
        </Typography>
      </DialogContent>
      <DialogContent sx={{ py: 16, backgroundColor: 'grey.100' }}>
        <AgentCodeSnippet
          testId="omni-onboarding-script"
          code={script}
          isLoading={isLoading || !script}
          error={error}
          refetch={refetch}
        />
      </DialogContent>
      <DialogActions sx={{ py: 16, justifyContent: 'flex-end' }}>
        <Button
          onClick={() => swipeableViewsCtx?.goToNextSlide()}
          testId="i-ran-script-button"
        >
          I ran the script
        </Button>
      </DialogActions>
    </Stack>
  );
};
